// DraggableBook.tsx
import React, { useState } from "react";
import { useDrag } from "react-dnd";
import { HydratedBook } from "./stateMachine/gameStateMachine";

export const DraggableBook = ({ book }: { book: HydratedBook }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "book",
    item: { book },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));
  const [isTapped, setIsTapped] = useState(false);

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
      }}
      onDoubleClick={() => {
        setIsTapped(!isTapped);
      }}
      onTouchStart={() => setIsTapped(true)}
      onTouchEnd={() => setIsTapped(false)}
    >
      <img src={book.image} id={book.id} key={book.id} draggable={true} />
      {isTapped && (
        <div className="show-on-hover-or-tap">{book.description}</div>
      )}
    </div>
  );
};

export default DraggableBook;
